import { FC } from "react";
import { Outlet } from "react-router-dom";
import "./AiDigitalHuman.scss";

export const AiDigitalHuman: FC = () => {
  return (
    <div className="adh-root">
      <Outlet />
    </div>
  );
};

export default AiDigitalHuman;
